module.exports = __webpack_public_path__ + "static/media/again-btn@2x.18d13efd.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_31/imgs/again-btn@2x.png
// module id = 917
// module chunks = 0